import { ISort } from '../types/sort';

const radios: ISort[] = [
  { title: 'A-Z', value: 'ASC' },
  { title: 'Z-A', value: 'DESC' }
];

export default radios;
